import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: [] as const,
	columnFields: [] as const,
	standardFilterFields: constants.file.search.standardFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
